import { useTranslation } from 'react-i18next';

function resolveValidationMessage(t, message) {
  if (!message) return '';

  try {
    const parsed = JSON.parse(message);
    if (parsed?.key) {
      return t(parsed.key, parsed.options || {});
    }
  } catch {
    return t(message);
  }

  return t(message);
}

export default function FormGroup({ children, label, error, counter, hint }) {
  const { t } = useTranslation();
  return (
    <div className={`formGroup ${error ? 'has-error' : ''}`}>
      {label && (
        <div className={`formGroup-label ${counter ? 'has-child' : ''}`}>
          <p className="secondary-text">{label}</p>
          {counter && <span className="tertiary-text">{counter}</span>}
        </div>
      )}
      {children}
      {hint && <p className="secondary-text hint-text">{hint}</p>}
      {error?.type === 'required' && (
        <p className="error-text">* {t('field_is_required')}</p>
      )}
      {error?.type === 'validate' && (
        <p
          className="error-text"
          dangerouslySetInnerHTML={{
            __html: '* ' + resolveValidationMessage(t, error.message),
          }}
        />
      )}
    </div>
  );
}
